<template>
  <div>
    <div v-if="isPreview">
      <input
        class="form-control disabled"
        :disabled="true"
        placeholder="Escribe tu respuesta"
        type="number"
        value="0"
      />
    </div>
    <custom-input
      v-else
      v-model="model"
      :disabled="isReadOnly"
      placeholder="Escribe tu respuesta"
      type="number"
    />
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
export default {
  name: 'RubricPreviewQuestionNumber',
  components: {
    CustomInput,
  },
  props: {
    value: [String, Number],
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return Number(this.value);
      },
      set(val) {
        this.$emit('input', Number(val));
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
